export default __webpack_public_path__ + "static/media/Icon-Kommunikation.a36800ee.svg";